/* EG Collections — Init (orchestrates modules; disables monolith via window.__egCollectionsSplitInit) */

(function () {

function egGetHeaderStatsConfig(handle) {
  var cfg = window.EG_COLLECTION_HEADER_STATS || {};
  var byHandle = cfg.handles || {};
  if (handle && byHandle[handle]) return byHandle[handle];
  return cfg.default || [];
}

function egGetFilterCollectionConfig(handle) {
  var cfg = window.EG_COLLECTION_FILTERS || {};
  var collections = cfg.collections || {};
  if (handle && collections[handle]) return collections[handle];
  return null;
}

function egGetTagGroupByKey(handle, key) {
  var col = egGetFilterCollectionConfig(handle);
  var groups = (col && col.tagGroups) ? col.tagGroups : [];

  for (var i = 0; i < groups.length; i++) {
    if (groups[i] && groups[i].key === key) return groups[i];
  }

  return null;
}

function egGetHeaderValueOrder(handle, key) {
  var col = egGetFilterCollectionConfig(handle);
  var valueOrder = (col && col.valueOrder) ? col.valueOrder : {};
  return valueOrder["tag." + key] || [];
}

function egIsArchivedHeaderProduct(p) {
  var v = (p && p.legacy_collection !== undefined) ? p.legacy_collection : null;
  return (v === true || v === 1 || v === "1" || v === "true");
}

function egApplyLegacyToggleToHeaderProducts(products) {
  var sp = new URLSearchParams(window.location.search || "");
  var showLegacy = sp.get("eg_show_legacy") === "1";

  if (showLegacy) return products || [];

  var out = [];
  for (var i = 0; i < (products || []).length; i++) {
    if (!egIsArchivedHeaderProduct(products[i])) out.push(products[i]);
  }
  return out;
}

function egExtractTagValueByPrefix(tag, prefix) {
  tag = String(tag || "");
  prefix = String(prefix || "");
  if (!tag || !prefix) return "";
  if (tag.indexOf(prefix) !== 0) return "";
  return tag.slice(prefix.length).replace(/^\s+|\s+$/g, "");
}

function egCollectValueCountsByPrefix(products, prefix) {
  var counts = {};
  var orderSeen = [];

  for (var i = 0; i < (products || []).length; i++) {
    var p = products[i];
    if (!p || !Array.isArray(p.tags)) continue;

    var seenThisProduct = {};
    for (var j = 0; j < p.tags.length; j++) {
      var raw = String(p.tags[j] || "");
      if (raw.indexOf(prefix) !== 0) continue;

      var val = egExtractTagValueByPrefix(raw, prefix);
      if (!val) continue;
      if (seenThisProduct[val]) continue;

      seenThisProduct[val] = true;
      counts[val] = (counts[val] || 0) + 1;

      if (orderSeen.indexOf(val) === -1) orderSeen.push(val);
    }
  }

  return { counts: counts, seenOrder: orderSeen };
}

function egSortHeaderStatRows(rows, preferredOrder) {
  preferredOrder = preferredOrder || [];

  rows.sort(function (a, b) {
    var ai = preferredOrder.indexOf(a.label);
    var bi = preferredOrder.indexOf(b.label);

    if (ai !== -1 && bi !== -1) return ai - bi;
    if (ai !== -1) return -1;
    if (bi !== -1) return 1;

    if (b.value !== a.value) return b.value - a.value;
    return String(a.label).localeCompare(String(b.label));
  });

  return rows;
}

function egBuildRowsFromTagGroup(products, handle, groupCfg) {
  if (!groupCfg || groupCfg.type !== "tag_group_bar" || !groupCfg.key) return [];

  var tagGroup = egGetTagGroupByKey(handle, groupCfg.key);
  if (!tagGroup || !tagGroup.match || !tagGroup.match.startsWith) return [];

  var prefix = String(tagGroup.match.startsWith || "");
  var collected = egCollectValueCountsByPrefix(products, prefix);
  var counts = collected.counts || {};
  var rows = [];
  var includedMap = {};
  var i;

  if (groupCfg.include && groupCfg.include.length) {
    for (i = 0; i < groupCfg.include.length; i++) {
      var label = String(groupCfg.include[i] || "");
      var val = counts[label] || 0;
      includedMap[label] = true;
      if (val > 0) {
        rows.push({ label: label, value: val });
      }
    }

    if (groupCfg.remainder_label) {
      var otherCount = 0;
      for (var k in counts) {
        if (!counts.hasOwnProperty(k)) continue;
        if (includedMap[k]) continue;
        otherCount += counts[k];
      }

      if (otherCount > 0) {
        rows.push({ label: String(groupCfg.remainder_label), value: otherCount });
      }
    }
  } else {
    for (var key in counts) {
      if (!counts.hasOwnProperty(key)) continue;
      if ((counts[key] || 0) <= 0) continue;
      rows.push({ label: key, value: counts[key] });
    }

    rows = egSortHeaderStatRows(rows, egGetHeaderValueOrder(handle, groupCfg.key));
  }

  return rows;
}

function egMakeHeaderBarRow(label, value, max) {
  var row = document.createElement("div");
  row.className = "eg-header-bar";

  var widthPct = 0;
  if (max > 0 && value > 0) widthPct = Math.max(6, Math.round((value / max) * 100));

  row.innerHTML =
    '<div class="eg-header-bar__meta">' +
      '<span class="eg-header-bar__label"></span>' +
      '<span class="eg-header-bar__value"></span>' +
    '</div>' +
    '<div class="eg-header-bar__track">' +
      '<div class="eg-header-bar__fill"></div>' +
    '</div>';

  var labelEl = row.querySelector(".eg-header-bar__label");
  var valueEl = row.querySelector(".eg-header-bar__value");
  var fillEl = row.querySelector(".eg-header-bar__fill");

  if (labelEl) labelEl.textContent = String(label);
  if (valueEl) valueEl.textContent = String(value);
  if (fillEl) fillEl.style.width = widthPct + "%";

  return row;
}

function egRenderHeaderStats(root) {
  if (!root) return;

  var customWrap = document.querySelector("[data-eg-header-stats]");
  var mobileWrap = document.querySelector("[data-eg-header-stats-mobile]");
  var baseWrap = document.querySelector("[data-eg-header-base-stats]");
  if (!customWrap && !mobileWrap && !baseWrap) return;

  var handle = String(root.getAttribute("data-eg-collection") || "");
  if (!handle || typeof egGetFullCollectionProducts !== "function") return;

  egGetFullCollectionProducts(handle).then(function (products) {
    products = products || [];

    var visibleProducts = egApplyLegacyToggleToHeaderProducts(products);

    var current = 0;
    var archived = 0;
    for (var i = 0; i < products.length; i++) {
      if (egIsArchivedHeaderProduct(products[i])) archived++;
      else current++;
    }

    if (baseWrap) {
      var currentEl = baseWrap.querySelector("[data-eg-current-count]");
      var archivedEl = baseWrap.querySelector("[data-eg-archived-count]");

      if (currentEl) currentEl.textContent = String(current);
      if (archivedEl) archivedEl.textContent = String(archived);
    }

      if (customWrap) {
        customWrap.innerHTML = "";
      }

      if (mobileWrap) {
        mobileWrap.innerHTML = "";
      }

      if (customWrap || mobileWrap) {

      var sp = new URLSearchParams(window.location.search || "");
      var showLegacy = sp.get("eg_show_legacy") === "1";

      var pillHost = document.querySelector("[data-eg-header-scope-pill]");
        if (pillHost) {
          pillHost.innerHTML =
            '<span class="eg-header-stats-scope__pill">' +
              (showLegacy ? 'EG Range + DB' : 'EG Range') +
            '</span>';
        }

      if (customWrap) {
        customWrap.classList.toggle("is-db-on", showLegacy);
        customWrap.classList.toggle("is-db-off", !showLegacy);
      }

      if (pillHost && pillHost.classList) {
        pillHost.classList.toggle("is-db-on", showLegacy);
        pillHost.classList.toggle("is-db-off", !showLegacy);
      }

      var summaryBits = [];
      var cfg = egGetHeaderStatsConfig(handle);

      for (var g = 0; g < cfg.length; g++) {
        var group = cfg[g];
        if (!group || group.type !== "tag_group_bar") continue;

        var rows = egBuildRowsFromTagGroup(visibleProducts, handle, group);
        if (!rows.length) continue;

        if (rows[0] && rows[0].label) {
          summaryBits.push(String(rows[0].label));
        }

        var max = 0;
        for (var r = 0; r < rows.length; r++) {
          if (rows[r].value > max) max = rows[r].value;
        }

        var groupEl = document.createElement("div");
        groupEl.className = "eg-header-bar-group";
        groupEl.innerHTML =
          '<div class="eg-header-bar-group__title"></div>' +
          '<div class="eg-header-bar-group__rows"></div>';

        var titleEl = groupEl.querySelector(".eg-header-bar-group__title");
        var rowsEl = groupEl.querySelector(".eg-header-bar-group__rows");

        if (titleEl) titleEl.textContent = String(group.title || "");

        for (var x = 0; x < rows.length; x++) {
          rowsEl.appendChild(egMakeHeaderBarRow(rows[x].label, rows[x].value, max));
        }

        if (customWrap) {
          customWrap.appendChild(groupEl.cloneNode(true));
        }

        if (mobileWrap) {
          mobileWrap.appendChild(groupEl.cloneNode(true));
        }
      }
      var mobileToggleTextEl = document.querySelector("[data-eg-header-stats-mobile-toggle] .eg-collection-panel__stats-mobile-toggle-text");
      if (mobileToggleTextEl) {
        mobileToggleTextEl.textContent = "Stats";
      }
    }
  })["catch"](function () {});
}

function egGetDbModeBlock() {
  return document.querySelector("[data-eg-db-mode]");
}

function egGetDbModeTextEl() {
  var block = egGetDbModeBlock();
  return block ? block.querySelector("[data-eg-db-mode-text]") : null;
}

function egIsDbModeOnFromUrl() {
  var sp = new URLSearchParams(window.location.search || "");
  return sp.get("eg_show_legacy") === "1";
}

function egReadDbModeMessageState() {
  var state = {
    dbOn: egIsDbModeOnFromUrl(),
    autoEnableDb: false,
    suggestDb: false
  };

  try {
    if (window.__egPickerLastApplyPlan) {
      state.autoEnableDb = !!window.__egPickerLastApplyPlan.autoEnableDb;
      state.suggestDb = !!window.__egPickerLastApplyPlan.suggestDb;
    }
  } catch (e) {}

  return state;
}

function egGetDbModeMessageText() {
  var state = egReadDbModeMessageState();

  if (state.dbOn && state.autoEnableDb) {
    return "Expanded to DB Mode because our range did not return strong enough matches.";
  }

  if (state.dbOn) {
    return "Showing EG Range and Compare Pool in the collection.";
  }

  if (state.suggestDb) {
    return "Showing the best matches from our range. Broader alternatives are available in DB Mode.";
  }

  return "Turn on the database to compare gear outside of the EG range.";
}

function egSyncDbModeBlockUi() {
  var block = egGetDbModeBlock();
  if (!block) return;

  var textEl = egGetDbModeTextEl();
  var state = egReadDbModeMessageState();

  var currentStat = block.querySelector('[data-eg-stat="current"]');
  var archivedStat = block.querySelector('[data-eg-stat="archived"]');

  if (textEl) {
    textEl.textContent = egGetDbModeMessageText();
  }

  block.classList.toggle("is-db-on", !!state.dbOn);
  block.classList.toggle("is-db-suggested", !state.dbOn && !!state.suggestDb);
  block.classList.toggle("is-db-auto", !!state.dbOn && !!state.autoEnableDb);

  if (currentStat) {
    currentStat.classList.add("is-active");
    currentStat.classList.remove("is-dimmed");
  }

  if (archivedStat) {
    archivedStat.classList.toggle("is-active", !!state.dbOn || !!state.suggestDb);
    archivedStat.classList.toggle("is-suggested", !state.dbOn && !!state.suggestDb);
  }
}

window.egSyncDbModeBlockUi = egSyncDbModeBlockUi;

function bindMobileHeaderStatsToggle() {
  if (window.__egMobileHeaderStatsToggleBound) return;
  window.__egMobileHeaderStatsToggleBound = true;

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-eg-header-stats-mobile-toggle]");
    if (!btn) return;

    var body = document.querySelector("[data-eg-header-stats-mobile-body]");
    if (!body) return;

    var isOpen = btn.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      btn.setAttribute("aria-expanded", "false");
      body.hidden = true;
    } else {
      btn.setAttribute("aria-expanded", "true");
      body.hidden = false;
    }
  });
}

function bindMobileHeaderGuidesToggle() {
  if (window.__egMobileHeaderGuidesToggleBound) return;
  window.__egMobileHeaderGuidesToggleBound = true;

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-eg-header-guides-mobile-toggle]");
    if (!btn) return;

    var body = document.querySelector("[data-eg-header-guides-mobile-body]");
    if (!body) return;

    var isOpen = btn.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      btn.setAttribute("aria-expanded", "false");
      body.hidden = true;
    } else {
      btn.setAttribute("aria-expanded", "true");
      body.hidden = false;
    }
  });
}

function bindLegacyToggle(root) {
  if (!root || root.__egLegacyToggleBound) return;
  root.__egLegacyToggleBound = true;

  var input = document.querySelector("[data-eg-legacy-toggle]");
  if (!input) return;

  var wrap = input.closest ? input.closest(".eg-collection-legacy-switch") : null;

  function isOn() {
    var sp = new URLSearchParams(window.location.search || "");
    return sp.get("eg_show_legacy") === "1";
  }

  function syncUi() {
    var on = isOn();

    input.checked = on;
    if (wrap && wrap.classList) {
      wrap.classList.toggle("is-on", on);
    }

    egSyncDbModeBlockUi();
  }

  input.addEventListener("change", function () {
    var u = new URL(window.location.href);

    if (u.searchParams.get("eg_show_legacy") === "1") {
      u.searchParams.delete("eg_show_legacy");
    } else {
      u.searchParams.set("eg_show_legacy", "1");
    }

    u.searchParams.delete("page");

    history.replaceState({}, "", u.toString());

    if (typeof egApplyPrettyUrlToAddressBar === "function") {
      try { egApplyPrettyUrlToAddressBar(); } catch (e3) {}
    }

    syncUi();
    try { egRenderHeaderStats(root); } catch (e4) {}

    if (root && typeof root.__egClientRenderRefresh === "function") {
      root.__egClientRenderRefresh();
    } else if (typeof egCollectionsRefresh === "function") {
      egCollectionsRefresh(root);
    } else if (typeof egClientRenderRefresh === "function") {
      egClientRenderRefresh(root);
    } else if (typeof egClientRenderInit === "function") {
      egClientRenderInit(root);
    }
  });

  syncUi();
}

  function bindEgSort(root) {
    if (!root || root.__egSortBound) return;
    root.__egSortBound = true;

    function getActiveSort() {
      try {
        var sp = new URLSearchParams(window.location.search || "");
        return sp.get("eg_sort") || "featured";
      } catch (e) {
        return "featured";
      }
    }

    function applySelectedUi() {
      var active = getActiveSort();

      // Sort options may be teleported into the overlay panel (not nested under .eg-sort anymore)
      var btns = document.querySelectorAll('.eg-filter-option[data-eg-sort]');
      for (var i = 0; i < btns.length; i++) {
        var k = btns[i].getAttribute("data-eg-sort") || "";
        if ((active || "featured") === (k || "featured")) btns[i].classList.add("is-selected");
        else btns[i].classList.remove("is-selected");
      }

      // Active styling on the Sort GROUP (identical mechanism as other filters)
      var on = !!active && active !== "featured";

      // Sort group is inside root; the options panel may be teleported elsewhere
      var sortGrp = root.querySelector(".eg-filter-group.eg-sort");

      if (sortGrp) {
        sortGrp.classList.toggle("has-selection", on);

        // Match other filters: active class on the visible button element
        var sortTitle = sortGrp.querySelector(".eg-filter-title");
        if (sortTitle) sortTitle.classList.toggle("has-selection", on);
      }
    }

    function mapShopifyToEg(v) {
      v = String(v || "");
      if (v === "price-ascending") return "price_asc";
      if (v === "price-descending") return "price_desc";
      if (v === "title-ascending") return "title_asc";
      if (v === "title-descending") return "title_desc";
      if (v === "created-descending" || v === "date-descending") return "newest";
      return "featured";
    }

    function setEgSort(sortKey) {
      var url;
      try {
        url = new URL(window.location.href);
      } catch (e) {
        return;
      }

      var sp = url.searchParams;

      if (!sortKey || sortKey === "featured") sp.delete("eg_sort");
      else sp.set("eg_sort", sortKey);

      sp.delete("page");
      url.search = sp.toString();

      // Write the updated URL to the address bar (without reloading)
      try { history.replaceState({}, "", url.toString()); } catch (e2) {}

      if (typeof egApplyPrettyUrlToAddressBar === "function") {
        try { egApplyPrettyUrlToAddressBar(); } catch (e3) {}
      }

      applySelectedUi();

      if (root && typeof root.__egClientRenderRefresh === "function") {
        root.__egClientRenderRefresh();
      }

      if (root.__egUpdateAllCounts) root.__egUpdateAllCounts();
      if (root.__egUpdateClearVisibility) root.__egUpdateClearVisibility();
    }

    document.addEventListener("click", function (e) {
      // Sort options may be teleported into the overlay panel; do NOT require .eg-sort ancestry
      var btn =
        e.target.closest('.eg-filter-option[data-eg-sort]') ||
        e.target.closest('.value-picker__choice-item[data-action="select-value"][data-value]') ||
        e.target.closest('[data-action="select-value"][data-value]');

      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      var egKey = btn.getAttribute("data-eg-sort");
      if (!egKey) {
        var shopifyVal = btn.getAttribute("data-value") || "";
        egKey = mapShopifyToEg(shopifyVal);
      }

      setEgSort(egKey);
    }, true);

    // Allow other modules (pills) to resync Sort UI after URL changes
    root.__egSyncSortUi = applySelectedUi;

    applySelectedUi();
  }

  function renderEgSortOptions(root) {
    if (!root) return;

    var cfg = window.EG_COLLECTION_SORT_CONFIG;
    if (!cfg || !cfg.defaults || !cfg.defaults.options) return;

    var defaults = Array.isArray(cfg.defaults.options) ? cfg.defaults.options : [];

    var handle = (root.dataset && root.dataset.egCollection) ? String(root.dataset.egCollection) : "";
    var col = (cfg.collections && handle && cfg.collections[handle]) ? cfg.collections[handle] : null;

    // Collection options may contain only custom items OR a full list (including defaults).
    // We always show defaults first, then append any extra options not in defaults.
    var colOpts = (col && Array.isArray(col.options)) ? col.options : [];

    var defaultKeys = {};
    for (var d = 0; d < defaults.length; d++) {
      if (defaults[d] && defaults[d].key) defaultKeys[String(defaults[d].key)] = 1;
    }

    var extras = [];
    for (var c = 0; c < colOpts.length; c++) {
      var o = colOpts[c];
      if (!o || !o.key) continue;
      var k = String(o.key);
      if (!defaultKeys[k]) extras.push(o);
    }

    var host = root.querySelector('[data-eg-sort-options]');
    if (!host) return;

    var tpl = root.querySelector('#eg-sort-option-template');
    if (!tpl || !tpl.content) return;

    // Clear existing
    host.innerHTML = "";

    function appendOpt(opt) {
      if (!opt || !opt.key) return;

      var node = tpl.content.firstElementChild
        ? tpl.content.firstElementChild.cloneNode(true)
        : null;

      if (!node) return;

      node.setAttribute("data-eg-sort", String(opt.key));

      var labelEl = node.querySelector(".eg-filter-option-label");
      if (labelEl) labelEl.textContent = String(opt.label || opt.key);

      host.appendChild(node);
    }

    // 1) Defaults (always)
    for (var i = 0; i < defaults.length; i++) appendOpt(defaults[i]);

    // 2) Divider + extras (only if extras exist)
    if (extras.length) {
      var div = document.createElement("div");
      div.className = "eg-sort-divider";
      div.setAttribute("aria-hidden", "true");
      host.appendChild(div);

      for (var j = 0; j < extras.length; j++) appendOpt(extras[j]);
    }
  }

  function bindMobileFiltersSheet() {
    if (window.__egMobileSheetBound) return;
    window.__egMobileSheetBound = true;

    function open() { document.documentElement.classList.add("eg-mobile-filters-open"); }
    function close() { document.documentElement.classList.remove("eg-mobile-filters-open"); }

    document.addEventListener("click", function (e) {
      // Desktop: do nothing (prevents extra work on every click)
      try {
        if (!(window.matchMedia && window.matchMedia("(max-width: 999px)").matches)) return;
      } catch (err) { return; }

      var openBtn = e.target.closest && e.target.closest("[data-eg-mobile-filters-open]");
      if (openBtn) { e.preventDefault(); open(); return; }

      var closeBtn = e.target.closest && e.target.closest("[data-eg-mobile-filters-close]");
      if (closeBtn) { e.preventDefault(); close(); return; }

      var see = e.target.closest && e.target.closest("[data-eg-mobile-see-products]");
      if (see) { e.preventDefault(); close(); return; }
    }, true);
  }

function egToggleDbModeVisibility(root) {
  if (!root || typeof egGetFullCollectionProducts !== "function") return;

  var panel = document.querySelector(".eg-collection-panel");
  var block = document.querySelector("[data-eg-db-mode]");
  var pillHost = document.querySelector("[data-eg-header-scope-pill]");
  var pickerRoot = document.querySelector("[data-eg-picker-root]");
  var guidesPanel = document.querySelector("[data-eg-header-guides-mobile-panel]");
  var desktopGuides = document.querySelector(".eg-collection-links");

  var handle = String(root.getAttribute("data-eg-collection") || "");

  function hasVisible(el) {
    if (!el) return false;
    return el.style.display !== "none";
  }

  function syncPanel(hasLegacy) {
    var hasPicker = hasVisible(pickerRoot);
    var hasGuides = false;

    if (desktopGuides && desktopGuides.querySelector("a")) hasGuides = true;
    if (guidesPanel && guidesPanel.querySelector("a")) hasGuides = true;

    if (panel) {
      panel.style.display = (hasLegacy || hasPicker || hasGuides) ? "" : "none";
    }
  }

  egGetFullCollectionProducts(handle).then(function (products) {
    products = products || [];

    var hasLegacy = false;

    for (var i = 0; i < products.length; i++) {
      var v = products[i] && products[i].legacy_collection;
      if (v === true || v === 1 || v === "1" || v === "true") {
        hasLegacy = true;
        break;
      }
    }

    if (block) block.style.display = hasLegacy ? "" : "none";
    if (pillHost) pillHost.style.display = hasLegacy ? "" : "none";

    syncPanel(hasLegacy);
  })["catch"](function () {
    if (block) block.style.display = "none";
    if (pillHost) pillHost.style.display = "none";

    syncPanel(false);
  });
}

  async function init() {
    const root = document.getElementById("eg-collection-filters");
    if (!root) return;

    bindMobileFiltersSheet();
    bindMobileHeaderStatsToggle();
    bindMobileHeaderGuidesToggle();

    // Build EG sort options from config (custom tag sorts etc.)
    renderEgSortOptions(root);

    document.documentElement.classList.add("eg-collection-loading");
    var egStartedClient = false;

    try {
      if (typeof applyCollectionFilterConfig === "function") {
        applyCollectionFilterConfig(root);
      }

      if (typeof renderTagGroups === "function") {
        renderTagGroups(root);

        // IMPORTANT: re-apply ordering now that tag groups exist
        if (typeof applyCollectionFilterConfig === "function") {
          applyCollectionFilterConfig(root);
        }
      }
      
      if (typeof bindDropdownOverlay === "function") bindDropdownOverlay(root);
      if (typeof bindMobileFiltersDrawer === "function") bindMobileFiltersDrawer(root);
      if (typeof bindPriceRangeNavigation === "function") bindPriceRangeNavigation(root);
      if (typeof bindClearFilters === "function") bindClearFilters(root);
      if (typeof bindPillMoreWrapper === "function") bindPillMoreWrapper(root);
      if (typeof bindEgSort === "function") bindEgSort(root);

      bindLegacyToggle(root);

      if (typeof window.egCollectionPickerInit === "function") {
        window.egCollectionPickerInit(root);
      }

      egRenderHeaderStats(root);
      egToggleDbModeVisibility(root);
      egSyncDbModeBlockUi();

      if (typeof egCompareInit === "function") {
        egCompareInit(root);
      }

      // Client-render must be started AFTER all helpers/UI exist
      if (typeof egClientRenderInit === "function") {
        window.EG_CLIENT_RENDER_ADVERTS = true;

      const ok = egClientRenderInit(root);
      if (ok) { egStartedClient = true; return; }
      }

      } finally {
        if (!egStartedClient) {
          document.documentElement.classList.remove("eg-collection-loading");
        }
      }
  }

  // Signal to the old monolith to not run (we'll add the guard next)
  window.__egCollectionsSplitInit = true;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
